import { indentstatusenum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";

export class IndentRequestformaterial {
    @ApiProperty()
    employeeId: number;
    @ApiProperty()
    saleOrderItemId: number;
}

export class RequestforIndentItem{
    @ApiProperty()
    indentMaterialPreparationId:number
}

export class Requestforindentstatusupdate{
    @ApiProperty()
    indentMaterialPreparationId:number
    status:indentstatusenum
}

export class IndentQuantityRequest{
    @ApiProperty()
    saleOrderId: number;
    @ApiProperty()
    itemId: number;
}